import styles from "@/styles/components/EmptyState.module.css"

/*
 * A slot that has nothing in it yet.
 *
 * Distinct from `StatusScreen`, which owns a whole screen when the session
 * cannot be shown. This is for a region inside a working screen — an empty
 * quadrant, a board nobody has written on, a bucket nothing landed in. Saying so
 * matters in a workshop: an empty Won't-have column is a result, and a blank
 * space reads like a bug.
 */

interface EmptyStateProps {
  title: string
  detail?: string
  /** Quieter, for a small slot inside a grid rather than a whole section. */
  compact?: boolean
}

export default function EmptyState({ title, detail, compact }: EmptyStateProps) {
  return (
    <div className={compact ? `${styles.empty} ${styles.compact}` : styles.empty}>
      <p className={styles.title}>{title}</p>
      {detail ? <p className={styles.detail}>{detail}</p> : null}
    </div>
  )
}
